import { makeStyles } from "tss-react/mui";

export default makeStyles({ name: "BalanceSheet" })((_theme) => ({
  page: {
    margin: "20px",
  },
  balanceSheetExportBtn: {
    display: "flex",
    justifyContent: "flex-end",
    marginRight: "10px",
    marginTop: "-30px",
  },
}));
